import { createSlice } from "@reduxjs/toolkit";
import { MainTextEnglish, MainTextArabic } from "./languageConst";
const initialState = {
  languageType: localStorage.language === "arabic" ? MainTextArabic : MainTextEnglish,
  language: localStorage.language || "english",
};
const LanguageReducer = createSlice({
  name: "LanguageReducer",
  initialState,
  reducers: {
    updateLanguage: (state, action) => {
      state.language = action.payload;
      if (action.payload === "arabic") {
        state.languageType = MainTextArabic;
      } else {
        state.languageType = MainTextEnglish;
      }
    },
  },
});
export const { updateLanguage } = LanguageReducer.actions;
export default LanguageReducer.reducer;
